angular.module('stack.common.storage.services.CookieStorageService', [
  'stack.common.storage.services.StorageParserService'
])

/**
 * The CookieStorageService service provides methods to handle
 * cookie-based storage operations.
 *
 * @class CookieStorageService
 * @constructor
 * @module stack.common.storage.services.CookieStorageService
 */
.factory('CookieStorageService', [
  'StorageParserService',
  function (StorageParserService) {
    'use strict';

    var service = {
      /**
       * Property houses the storage type.
       *
       * @property storageType
       * @type String
       */
      storageType: 'Cookie',

      /**
       * Method returns the value of the stored key.
       *
       * @param {string} key - Key identifier for a property
       * @return {*} Value of the stored property
       */
      get: function get(key) {
        return !$.cookie(key) ? null : StorageParserService.parse($.cookie(key));
      },

      /**
       * Method stores the value on the passed key property.
       *
       * @param {string} key - Key identifier for a property
       * @param {string} value - Value for the stored property
       */
      set: function set(key, value) {
        $.cookie(key, StorageParserService.stringify(value));
      },

      /**
       * Method removes the value from storage.
       *
       * @param {string} key - Key identifier for a property
       */
      remove: function remove(key) {
        $.removeCookie(key);
      },

      /**
       * Method clears all properties from storage.
       */
      clear: function clear() {
        var cookies = $.cookie();
        angular.forEach(cookies, function (value, key) {
          service.remove(key);
        });
      }
    };

    return service;
  }
]);
